import * as _ from 'lodash'

export const newProducts = (products) => {
    const productsFilter = _.filter(products, product => {
        return product.Estado === 'NUEVO' || product.Estado === 'PROXIMAMENTE';
    })
    if (productsFilter.length > 0) {
        return true
    } else {
        return false
    }

}